export const JUST_ONE_PAGE_NAME = 'Just One Page';
export const JUST_ONE_PAGE_LOGO = '/just-one-page-logo.png';
export const JUST_ONE_PAGE_TAGLINE =
  'Créez, prévisualisez et publiez vos landing pages en une seule page.';
export const JUST_ONE_PAGE_FOOTER_URL = 'https://deepblock.eu';
export const JUST_ONE_PAGE_FOOTER_LINK_LABEL = 'deepblock.eu';
